import { useEffect } from "react";
import { COMPANY } from "@/config/company";

const SITE = COMPANY.name;

export default function SEO({ title, description, path = "/", breadcrumbs, schema, ogImage }) {
  useEffect(() => {
    const fullTitle = title ? `${title} | ${SITE}` : `${SITE} — ISO, Cybersecurity & Risk Advisory`;
    document.title = fullTitle;

    const setMeta = (selector, attr, value) => {
      let el = document.head.querySelector(selector);
      if (!el) {
        el = document.createElement("meta");
        const [key, kval] = selector.replace(/[[\]']/g, "").split("=");
        el.setAttribute(key, kval);
        document.head.appendChild(el);
      }
      el.setAttribute(attr, value);
    };

    setMeta("meta[name='description']", "content", description);
    setMeta("meta[property='og:title']", "content", fullTitle);
    setMeta("meta[property='og:description']", "content", description);
    setMeta("meta[property='og:url']", "content", window.location.origin + path);
    setMeta("meta[property='og:image']", "content", window.location.origin + (ogImage || "/logo.png"));

    let canonical = document.head.querySelector("link[rel='canonical']");
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", window.location.origin + path);

    document.getElementById("breadcrumb-jsonld")?.remove();
    if (breadcrumbs?.length) {
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.id = "breadcrumb-jsonld";
      script.textContent = JSON.stringify({
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: breadcrumbs.map((b, i) => ({
          "@type": "ListItem",
          position: i + 1,
          name: b.name,
          item: window.location.origin + b.path,
        })),
      });
      document.head.appendChild(script);
    }
    document.getElementById("page-jsonld")?.remove();
    if (schema) {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.id = "page-jsonld";
      s.textContent = JSON.stringify(schema);
      document.head.appendChild(s);
    }
  }, [title, description, path, breadcrumbs, schema, ogImage]);

  return null;
}
